module.exports = __webpack_public_path__ + "img/case-ct_capsule.8417bf9.png";